import { Component, HostListener } from '@angular/core';
import { DevextremesharedmoduleModule } from '../../Module/devextremeshared/devextremeshared.module';
import { Router, RouterModule } from '@angular/router';
import { About } from '../../../classes/domain/entities/website/masters/landing-page/about/about';
import { UIUtils } from '../../../services/uiutils.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HealthDepartmentProfile } from '../../../classes/domain/entities/website/masters/landing-page/health-department-profile/healthdepartmentprofile';
import { BaseUrlService } from '../../../services/baseurl.service';
import { WorkGallery } from '../../../classes/domain/entities/website/masters/landing-page/work-gallery/workgallery';
import { TrainingVideo } from '../../../classes/domain/entities/website/masters/landing-page/training-video/trainingvideo';

// ← Add these two imports
import { LanguageService } from '../../../services/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  standalone: true,
  imports: [DevextremesharedmoduleModule, RouterModule   ],
})
export class LandingPageComponent {
  MasterList: About[] = [];
  dataSource: About[] = [];

  aboutData: any = null;
  aboutHtml: SafeHtml = '';

  MasterListForHealthProfile: HealthDepartmentProfile[] = [];
  dataSourceForHealthProfile: HealthDepartmentProfile[] = [];
  ImageBaseUrl: string = "";

  MasterListForWorkGallery: WorkGallery[] = [];
  dataSourceForWorkGallery: WorkGallery[] = [];
  menuOpen = false;

  MasterListForTrainingVideos: TrainingVideo[] = [];
  dataSourceForTrainingVideos: TrainingVideo[] = [];

  constructor(
    private router: Router,
    private uiUtils: UIUtils,
    private sanitizer: DomSanitizer,
    private baseUrl: BaseUrlService,
    public langService: LanguageService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.FormulateAbout();
    this.FormulateHealthDepartmentProfile();
    this.FormulateWorkGallery();
    this.FormulateTrainingVideo();
  }

  globeOpen = false;

  toggleGlobe(event: MouseEvent): void {
    event?.stopPropagation();
    this.globeOpen = !this.globeOpen;
  }

  closeGlobe(): void {
    this.globeOpen = false;
  }

  switchLang(lang: 'en' | 'mr'): void {
    this.langService.switchLanguage(lang);
    this.updateAboutHtml();
    this.globeOpen = false;  
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.globe-toggle')) {
      this.globeOpen = false;
    }
  }

  // picks correct language HTML from backend data
  private updateAboutHtml(): void {
    if (!this.aboutData) return;
    const html = this.langService.currentLang === 'mr'
      ? this.aboutData.p?.description_mr
      : this.aboutData.p?.description_en;
    this.aboutHtml = this.sanitizer.bypassSecurityTrustHtml(html ?? '');
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    document.body.style.overflow = this.menuOpen ? 'hidden' : '';
  }

  closeMenu(): void {
    this.menuOpen = false;
    document.body.style.overflow = '';
  }

  goToLogin(): void {
    this.closeMenu();
    this.router.navigate(['/login-form']);
  }

  seeAllGallery(): void {
    // this.router.navigate(['/gallery']);
  }

  public async FormulateAbout(): Promise<void> {
    this.MasterList = [];
    let lst = await About.FetchEntireListWithoutLoginToken(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg)
    );
    this.MasterList = lst;
    this.dataSource = [...lst];
    console.log('datasource', this.dataSource);

    if (lst && lst.length > 0) {
      this.aboutData = lst[0];
      this.updateAboutHtml();  
    }
  }

  public async FormulateHealthDepartmentProfile(): Promise<void> {
    this.MasterList = [];
    let lst = await HealthDepartmentProfile.FetchEntireListWithoutLoginToken(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    lst.sort((a, b) => Number(a.p.seniority_level) - Number(b.p.seniority_level));
    this.MasterListForHealthProfile = lst;
    this.dataSourceForHealthProfile = lst.map((item) => {
      let imageUrl = item.p.profile_pic_path;
      let ImageBaseUrl = this.baseUrl.GenerateImageBaseUrlWithoutLoginToken();
      item.p.image_blob_url = ImageBaseUrl + imageUrl;
      return item;
    });
    console.log('Health commity', this.dataSourceForHealthProfile);
  }

  public async FormulateWorkGallery(): Promise<void> {
    this.MasterListForWorkGallery = [];
    let lst = await WorkGallery.FetchEntireListWithoutLoginToken(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    this.MasterListForWorkGallery = lst;
    this.dataSourceForWorkGallery = lst.map((item) => {
      let imageUrl = item.p.image_path;
      let ImageBaseUrl = this.baseUrl.GenerateImageBaseUrlWithoutLoginToken();
      item.p.image_blob_url = ImageBaseUrl + imageUrl;
      return item;
    });
    console.log('Masterlist For Work Gallery', this.dataSourceForWorkGallery);
  }

  public async FormulateTrainingVideo(): Promise<void> {
    this.MasterListForTrainingVideos = [];
    let lst = await TrainingVideo.FetchEntireListWithoutLogintoken(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    this.MasterList = lst;
    this.MasterListForTrainingVideos = lst;
    this.dataSourceForTrainingVideos = [...lst];
    console.log('dataSourceForTrainingVideos', this.dataSourceForTrainingVideos);
  }

  public openVideo(url: string): void {
    window.open(url, '_blank');
  }

  public getYoutubeThumbnail(url: string): string {
    const match = url.match(/(?:v=|youtu\.be\/)([^&?\s]+)/);
    const videoId = match ? match[1] : '';
    return videoId
      ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
      : 'assets/landingpageicon/ashahero.png';
  }
}